import { memo } from "react";
import dayjs from "dayjs";
import relative from "dayjs/plugin/relativeTime";
import Page from "../Page";
import styles from "./Home.module.css";
import clsx from "clsx";
// import Tokenomics from "./Tokenomics";
import FeatureSection from "./FeatureSection";
import Hero from "./Hero";
import Footer from "components/Footer";
import Features from "./Features";
import useLeaderboard from "rest/useLeaderboard";
import useWallets from "rest/useWallets";
import Skeleton from "components/Skeleton";
import { getFormattedValue } from "libs/getFormattedValue";
// import Modal from "./ModalV2";

dayjs.extend(relative);

const Home = () => {
  const { walletCount, walletCountLoading } = useWallets();
  return (
    <Page>
      <div
        className={clsx(
          styles.container,
          "z-0 max-w-11xl relative mx-auto w-full"
        )}>
        <div className="my-14 md:my-32">
          <div className="px-3">
            <Hero />

            {/* <FeatureSection
              iconSrc="/images/injera/hexagons/heartbeat.svg"
              title="GROWTH STATS"
              className="mt-40">
              <div className="grid grid-cols-3 divide-x divide-slate-700 mt-6 max-w-4xl mx-auto text-center">
                <div className="px-12">
                  <div className="text-4xl">
                    {walletCountLoading ? (
                      <Skeleton />
                    ) : (
                      getFormattedValue(walletCount, false, true)
                    )}
                  </div>
                  <div className="text-sm uppercase font-bold mt-0.5">
                    Users
                  </div>
                </div>
                <div className="px-12">
                  <div className="text-2xl h-[40px] font-medium flex items-center justify-center">
                    AVAILABLE SOON
                  </div>
                  <div className="text-sm uppercase font-bold mt-0.5">TVL</div>
                </div>
                <div className="px-12">
                  <div className="text-2xl h-[40px] font-medium flex items-center justify-center">
                    AVAILABLE SOON
                  </div>
                  <div className="text-sm uppercase font-bold mt-0.5">
                    USDi APY
                  </div>
                </div>
              </div>
            </FeatureSection> */}

            <FeatureSection
              iconSrc="/images/injera/hexagons/mountain.svg"
              title="CORE FEATURES"
              className="mt-40">
              <Features />
            </FeatureSection>

            <FeatureSection
              iconSrc="/images/injera/hexagons/atoms.svg"
              title="OUR ECOSYSTEM"
              className="mt-40">
              <div className="mx-auto h-full max-w-3xl p-3">
                <div className="w-full">
                  <div className="grid grid-cols-12 gap-3">
                    <div className="text-white border border-white rounded-xl p-3 col-span-12 sm:col-span-4">
                      <div className="text-center font-bold">MARKET MAKER</div>
                      <div className="p-3 flex justify-center items-center">
                        <img
                          src="/images/injera/partners/pynx-white.png"
                          alt="pynx"
                          className="w-auto h-10"
                        />
                      </div>
                    </div>
                    <div className="col-span-12 sm:col-span-8">
                      <div className="text-white border border-white p-3 rounded-xl">
                        <div className="text-center font-bold">CUSTODIANS</div>
                        <div className="grid grid-cols-2 gap-3">
                          <div className="p-3 flex justify-center items-center">
                            <img
                              src="/images/injera/partners/copper.svg"
                              alt="copper"
                              className="w-auto h-10"
                            />
                          </div>
                          <div className="p-3 flex justify-center items-center">
                            <img
                              src="/images/injera/partners/ceffu.svg"
                              alt="ceffu"
                              className="w-auto h-10"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-white border border-white rounded-xl p-3 col-span-12 md:col-span-6">
                      <div className="text-center font-bold">WALLETS</div>
                      <div className="p-3 flex justify-center items-center gap-6">
                        <img
                          src="/images/wallets/metamask.svg"
                          alt="metamask"
                          className="w-10 h-10 block"
                        />
                        <img
                          src="/images/wallets/okx.svg"
                          alt="okx wallet"
                          className="w-10 h-10 block"
                        />
                        <img
                          src="/images/wallets/keplr.svg"
                          alt="keplr"
                          className="w-10 h-10 block"
                        />
                        <img
                          src="/images/wallets/leap.svg"
                          alt="leap"
                          className="w-10 h-10 block"
                        />
                        <img
                          src="/images/wallets/trust-wallet.svg"
                          alt="trust wallet"
                          className="w-10 h-10 block"
                        />
                      </div>
                    </div>
                    <div className="text-white border border-white rounded-xl p-3 col-span-6 md:col-span-3">
                      <div className="text-center font-bold">ORACLE</div>
                      <div className="p-3 flex justify-center items-center">
                        <img
                          src="/images/injera/partners/pyth.svg"
                          alt="pyth"
                          className="w-auto h-10"
                        />
                      </div>
                    </div>
                    <div className="text-white border border-white rounded-xl p-3 col-span-6 md:col-span-3">
                      <div className="text-center font-bold">AUDITOR</div>
                      <div className="p-3 flex justify-center items-center">
                        <img
                          src="/images/injera/partners/scv.png"
                          alt="scv"
                          className="w-auto h-10"
                        />
                      </div>
                    </div>
                    <div className="text-white border border-white rounded-xl p-3 col-span-12">
                      <div className="text-center font-bold">EXCHANGES</div>
                      <div className="grid grid-cols-4 gap-3">
                        <div className="p-3 flex justify-center items-center">
                          <img
                            src="/images/injera/partners/binance.svg"
                            alt="binance"
                            className="w-auto h-10"
                          />
                        </div>
                        <div className="p-3 flex justify-center items-center">
                          <img
                            src="/images/injera/partners/okx.svg"
                            alt="okx"
                            className="w-auto h-7"
                          />
                        </div>
                        <div className="p-3 flex justify-center items-center">
                          <img
                            src="/images/injera/partners/bybit.svg"
                            alt="bybit"
                            className="w-auto h-10"
                          />
                        </div>
                        <div className="p-3 flex justify-center items-center">
                          <img
                            src="/images/injera/partners/deribit.svg"
                            alt="deribit"
                            className="w-auto h-10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </FeatureSection>

            {/* <FeatureSection
              iconSrc="/images/injera/hexagons/donut.svg"
              title="TOKENOMICS"
              className="mt-40">
              <img
                src="/images/injera/tokenomics.png"
                alt="tokenomics"
                className="w-full max-w-2xl xl:hidden mx-auto"
              />
              <div className="hidden xl:block">
                <Tokenomics />
              </div>
            </FeatureSection> */}

            {/* <div className="mt-24 mb-3">
              <img
                src="/images/injera/hexagons/handshake.svg"
                alt="INJERA"
                className="w-14 h-14 mx-auto mb-3"
              />
              <div className="text-center text-lg">OUR PARTNERS</div>
            </div> */}
            <Footer />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default memo(Home);
